import { ChevronLeft } from 'lucide-react';

import { useGenericBi } from '../../../lib/use-generic-bi';
import { useTranslation } from '../../../lib/i18n';
import { Button } from '../ui';
import { PACK_DETAILS_PAGE } from './constants';
import styles from './PackDashboardBanner.module.css';

// The header pinned above a dashboard opened FROM a pack: a clear "‹ Back to pack" bar that both
// signals the drill-in is scoped to the pack (not the owner's own workspace) and returns to it. The
// drill-in is only ever reached from a pack, so this is the one navigation out.
export function PackDashboardBanner({ onBack }: { onBack: () => void }) {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  return (
    <div className={styles.banner}>
      <Button
        variant="text"
        size="small"
        startIcon={<ChevronLeft size={16} aria-hidden className="dir-flip" />}
        onClick={() => {
          logPageClickBi({ page_name: PACK_DETAILS_PAGE, button_name: 'back_to_pack' });
          onBack();
        }}
      >
        {t('packs.dashboard.backToPack')}
      </Button>
    </div>
  );
}
